import styled from 'styled-components';

export const Header = styled.div`
    height: 8%;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #FFFFFF;
    padding: 5px;
`;

export const Logo = styled.img`
    object-fit: cover;
    height: 80%;
`;